<template>
    <SideModal :sides="navs">
        <template :slot="'homologar'">
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12" style="min-height: 65vh;">
                        <h3>As ações deste compromisso</h3>
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th class="text-center">Inicio</th>
                                    <th class="text-center">Descritivo</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Responsável</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="homologarData.acoes && homologarData.acoes.length === 0">
                                    <td class="text-center" colspan="4">Nenhuma ação foi cadastrada.</td>
                                </tr>
                                <tr 
                                    v-for="({ 
                                        id, 
                                        data_inicio, 
                                        descritivo, 
                                        status, 
                                        data_conclusao, 
                                        data_estimada_conclusao, 
                                        responsavel, 
                                        justificativa_rejeicao, 
                                        updated_at 
                                    }) in homologarData.acoes"
                                    :key="id"
                                >
                                    <td>{{ data_inicio }}</td>
                                    <td :title="descritivo" style="cursor: pointer;">
                                        {{ `${descritivo.substring(0, 100)}...` }}
                                    </td>
                                    <td>
                                        <div 
                                            v-if="status === 'Não Iniciado'" 
                                            class="status"
                                            :title="`Previsão de inicio em ${data_inicio}`"
                                        >
                                            <font-awesome-icon :icon="'hourglass-start'" class="icon" />
                                            {{ status }}
                                        </div>

                                        <div 
                                            v-if="status === 'Em andamento'" 
                                            class="status"
                                            :title="`Estimativa de conclusão em ${data_estimada_conclusao}`"
                                        >
                                            <font-awesome-icon :icon="'clock'" class="icon" />
                                            {{ status }}
                                        </div>

                                        <div 
                                            v-if="status === 'Concluído'" 
                                            class="status"
                                            :title="`Concluído em ${data_conclusao}`"
                                        >
                                            <font-awesome-icon :icon="'check-square'" class="icon" />
                                            {{ status }}
                                        </div>

                                        <div 
                                            v-if="status === 'Rejeitada'" 
                                            class="status"
                                            :title="`Justificativa ${justificativa_rejeicao}`"
                                        >
                                            <font-awesome-icon :icon="'times'" class="icon" />
                                            {{ status }}
                                        </div>

                                        <div 
                                            v-if="status === 'Cancelada'" 
                                            class="status"
                                            :title="`Cancelado em ${updated_at}`"
                                        >
                                            <font-awesome-icon :icon="'ban'" class="icon" />
                                            {{ status }}
                                        </div>

                                    </td>
                                    <td :title="responsavel.sshd">
                                        <div class="">
                                            {{ responsavel }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button 
                            class="btn btn-success" 
                            :disabled="homologarData.acoes && homologarData.acoes.length === 0"
                            @click="$emit('homologar', homologarData.id)"
                        >
                            Homologar
                        </button>
                        <button 
                            class="btn btn-default"
                            @click="$emit('fechaModal', homologarData.identidade)"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template :slot="'info'">
            <main>
                <div class="col-xs-12 col-sm-6">
                    <label>Período</label>
                    <p>
                        {{ infoData.periodo }}
                    </p>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <label>Unidade</label>
                    <p>
                        {{ infoData.unidade_executora }}
                    </p>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <label>
                        Responsável
                    </label>
                    <p v-if="infoData.hasOwnProperty('responsavel')">
                        {{ infoData.responsavel.nome }}
                    </p>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <label>Status</label>
                    <p>
                        {{ infoData.status }}
                    </p>
                </div>
                <div v-if="infoData.justificativa_cancelamento" class="col-xs-12">
                    <label>Justificativa de Cancelamento</label>
                    <p>{{ infoData.justificativa_cancelamento }}</p>
                </div>
                <div v-else class="col-xs-12">
                    <label>Data de conclusão</label>
                    <p v-if="infoData.data_conclusao">
                        {{ infoData.data_conclusao }}
                    </p>
                    <p v-else>
                        Não definida
                    </p>
                </div>
                <div class="col-xs-12">
                    <label>Sumário das ações</label>
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="infoData.sumario && infoData.sumario.length === 0">
                                <td class="text-center" colspan="4">Nenhuma ação foi cadastrada.</td>
                            </tr>
                            <tr v-for="({ status, total }) in infoData.sumario" :key="status">
                                <td>{{ status }}</td>
                                <td>
                                    {{ total }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </main>
        </template>
        <template :slot="'cancelar'">
            <main>
                <textarea v-model="justificativa" class="form-control" cols="40" rows="5"></textarea>

                <div class="modal-footer">
                    <button class="btn btn-success"
                        @click="$emit('cancelar', cancelarData.id, justificativa)">Salvar</button>
                    <button class="btn btn-default" @click="$emit('fechaModal', cancelarData.identidade)">Sair</button>
                </div>
            </main>
        </template>
    </SideModal>
</template>
  
<script>
import { SideModal } from '../common'

export default {
    name: 'SidePlanoGoverno',
    components: { SideModal },
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            justificativa: ''
        }
    },
    computed: {
        homologarData() {
            const { identidade, data } = this.navs[0]

            return { identidade, ...data }
        },
        infoData() {
            const [{ identidade }, { data = {} }] = this.navs;
            const { acoes = [] } = data || {};

            const status = [...new Set(acoes.map(a => a.status))];
            const sumario = status.map(s => {
                const total = acoes.filter(a => a.status === s).length;
                return { status: s, total };
            });

            return { identidade, ...data, sumario }
        },
        cancelarData() {
            const cancelarNav = this.navs.find(n => n.identidade === 'cancelar')
            if (cancelarNav && cancelarNav.data) {
                return { identidade: cancelarNav.identidade, ...cancelarNav.data };
            }
            return { identidade: 'cancelar' };
        }
    }
}
</script>

<style scoped>
h3 {
    margin-top: 0px;
}

main {
    padding-left: 32px;
    padding-right: 32px;
    font-size: 2rem;
}

main table {
    margin-top: 8px;
    font-size: 1.7rem;
}

.status {
    display: flex;
    gap: 8px;
    justify-content: left;
    align-items: center;
    min-width: 110px;
    cursor: pointer;
    text-wrap: nowrap;
}

.user {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/planogoverno/SidePlanoGoverno.vue